import React, { useEffect } from 'react';
import styles from './faqs.module.css';

const PDF_URL = '/assets/faqs-and-definitions.pdf';

export default function Faqs() {
  useEffect(() => {
    document.title = 'KNOW - FAQs and Definitions';
  }, []);

  return (
    <div className={styles.faqsContainer} role="main" aria-label="FAQs and definitions">
      <h1>FAQs and Definitions</h1>
      <iframe className={styles.pdfViewer} src={PDF_URL} title="FAQs and Definitions" />
      <p className={styles.fallbackLink}>
        Trouble viewing the document?{' '}
        <a href={PDF_URL} target="_blank" rel="noopener noreferrer">
          Open FAQs and Definitions in a new tab
        </a>
      </p>
    </div>
  );
}
